import SubApp from './SubApp';

export default SubApp;
